import { ViewFullDetailsUI } from "./ViewFullDetailsUI";
import { StandardProps } from "../componentMap";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";

export function ViewFullDetails({ flags }: Pick<StandardProps, "flags">) {
  const appendPreviewToUrl = Boolean(flags?.showPreview.value);
  const router = useRouter();

  useEffect(() => {
    if (!appendPreviewToUrl) return;

    const updatedQuery = {
      ...router.query,
      preview: appendPreviewToUrl,
    };

    router.replace({ ...router, query: updatedQuery }, undefined, {
      shallow: true,
    });
  }, []);

  const handleViewFullDetailsPage = () => {
    const currentURL = window.location.href;
    const parameterToRemove = "preview";
    const newURL = removeParamFromURL(currentURL, parameterToRemove);

    if (newURL !== currentURL) {
      dispatchMonetateQEvent(
        "product-pages-preview-page-click-on-view-full-details",
      );
      window.location.href = newURL;
    }
  };

  return (
    <ViewFullDetailsUI handleViewFullDetailsPage={handleViewFullDetailsPage} />
  );
}

function removeParamFromURL(url: string, parameterName: string) {
  try {
    const urlObject = new URL(url);
    const params = new URLSearchParams(urlObject.search);

    params.delete(parameterName);
    urlObject.search = params.toString();

    return urlObject.toString();
  } catch (error) {
    return url;
  }
}
